export default {
  'statistics.abap.os.cpu.field.usage.rate': {
    ko: '사용률',
    ja: '使用率',
    en: 'Usage Rate',
    cn: '',
  },
  'statistics.status': {
    ko: '상태',
    ja: '状態',
    en: 'status',
    cn: '',
  },
  'statistics.java.p4.field.exported.remote.objectes.count': {
    ko: 'Exported Remote Objects Count',
    ja: 'エクスポートされたリモートオブジェクト数',
    en: 'Exported Remote Objects Count',
    cn: '',
  },
  'statistics.abap.os.memory.field.memory.usage.rate': {
    ko: '메모리 사용률',
    ja: 'メモリ使用率',
    en: 'Memory Usage Rate',
    cn: '',
  },
  'statistics.java.http.sssn.field.http.session.count': {
    ko: 'HTTP session count',
    ja: 'HTTPセッション数',
    en: 'HTTP session count',
    cn: '',
  },
  'statistics.tcode': {
    ko: 'T-Code',
    ja: 'Tコード',
    en: 'T-Code',
    cn: '',
  },
  'statistics.abap.duplication.id.field.easy.dup': {
    ko: 'Easy Dup',
    ja: 'Easy Dup',
    en: 'Easy Dup',
    cn: '',
  },
  'statistics.restart.selected': {
    ko: '선택된 통계 재실행',
    en: 'Restart selected',
    cn: 'Restart selected',
    ja: 'Restart selected',
  },
  'statistics.java.os.network.field.tx': {
    ko: 'Tx',
    ja: 'Tx',
    en: 'Tx',
    cn: '',
  },
  'statistics.abap.lock.field.enqueue': {
    ko: 'Enqueue',
    ja: 'エンキュー',
    en: 'Enqueue',
    cn: '',
  },
  'statistics.java.os.cpu.field.usage.rate': {
    ko: '사용률',
    ja: '使用率',
    en: 'Usage Rate',
    cn: '',
  },
  'statistics.avg': {
    ko: '평균',
    ja: '平均',
    en: 'Average',
    cn: '',
  },
  'statistics.java.os.disk.mr.sec': {
    ko: 'Read for second',
    ja: 'Read for second',
    en: 'Read for second',
    cn: '',
  },
  'statistics.batch.datim': {
    ko: '실행 일시',
    ja: '実行日時',
    en: 'Time run batch',
    cn: '',
  },
  'statistics.java.jsp.field.response.time': {
    ko: '응답 시간',
    ja: '応答時間',
    en: 'Response time',
    cn: '',
  },
  'statistics.confirm.collect': {
    ko: '집계가 누락된 기간을 올바르게 선택하셨습니까? 선택된 기간에 따라 집계에 오랜 시간이 소요될 수 있습니다. 실행하시겠습니까?',
    ja: '集計の欠落された期間を正しく選択しましたか？選択された期間によっては、集計に時間がかかる場合があります。実行しますか？',
    en: 'Did you select the correct period for which aggregation is missing? Depending on the period selected, aggregation job may take a long time. Do you want to run it?',
    cn: '',
  },
  'statistics.java.trxn.field.committed.count': {
    ko: 'Committed',
    ja: 'コミット済み',
    en: 'Committed',
    cn: '',
  },
  'statistics.granularity': {
    ko: '간격',
    ja: '間隔',
    en: 'Granularity',
    cn: '',
  },
  'statistics.abap.logon.user.field.gui': {
    ko: 'GUI',
    ja: 'GUI',
    en: 'GUI',
    cn: '',
  },
  'statistics.java.system.thread.field.thread.pool.usage.rate': {
    ko: 'Thread Pool Usage Rate',
    ja: 'スレッドプールの使用率',
    en: 'Thread Pool Usage Rate',
    cn: '',
  },
  'statistics.abap.logon.user.field.plugin': {
    ko: 'Plugin',
    ja: 'プラグイン',
    en: 'Plugin',
    cn: '',
  },
  'statistics.java.system.thread.field.current.thread.count': {
    ko: 'Currnet Thread Count',
    ja: '現在のスレッド数',
    en: 'Currnet Thread Count',
    cn: '',
  },
  'statistics.system': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
    cn: '',
  },
  'statistics.abap.syslog.field.count': {
    ko: 'Log Count',
    ja: 'ログ数',
    en: 'Log Count',
    cn: '',
  },
  'statistics.memory': {
    ko: '메모리',
    ja: 'メモリ',
    en: 'Memory',
    cn: '',
  },
  'statistics.queue': {
    ko: '큐',
    ja: 'キュー',
    en: 'Queue',
    cn: '',
  },
  'statistics.java.jsp.field.request.count': {
    ko: '요청 수',
    ja: 'リクエスト数',
    en: 'Request Count',
    cn: '',
  },
  'statistics.msg.is.running': {
    ko: '통계 배치 작업이 진행중입니다.',
    ja: '統計バッチ作業が進行中です。',
    en: 'The batch process is already running.',
    cn: '',
  },
  'statistics.java.trxn.field.rolledback.count': {
    ko: 'Rolledback',
    ja: 'ロールバック',
    en: 'Rolledback',
    cn: '',
  },
  'statistics.java.system.thread.field.waiting.tasks.count': {
    ko: 'Waiting Tasks Count',
    ja: '待機中のタスク数',
    en: 'Waiting Tasks Count',
    cn: '',
  },
  'statistics.java.p4.field.request.count': {
    ko: '요청 수',
    ja: 'リクエスト数',
    en: 'Request Count',
    cn: '',
  },
  'statistics.java.application.thread.field.waiting.tasks.count': {
    ko: 'Waiting Tasks',
    ja: '待機中のタスク',
    en: 'Waiting Tasks',
    cn: '',
  },
  'statistics.buffer': {
    ko: '버퍼',
    ja: 'バッファ',
    en: 'Buffer',
    cn: '',
  },
  'statistics.java.application.thread.field.thread.pool.capacity.rate': {
    ko: 'Thread Pool Capacity',
    ja: 'スレッドプール容量',
    en: 'Thread Pool Capacity',
    cn: '',
  },
  'statistics.abap.work.process.field.count': {
    ko: '개수',
    ja: '数',
    en: 'Count',
    cn: '',
  },
  'statistics.fiveM': {
    ko: '5분',
    ja: '5分',
    en: '5minutes',
    cn: '',
  },
  'statistics.output': {
    ko: '출력',
    ja: '出力',
    en: 'Output',
    cn: '',
  },
  'statistics.abap.os.network.field.out.errors': {
    ko: 'Out Errors',
    ja: '出力エラー',
    en: 'Out Errors',
    cn: '',
  },
  'statistics.abap.transaction.field.throughput': {
    ko: 'Throughput',
    ja: 'スループット',
    en: 'Throughput',
    cn: '',
  },
  'statistics.java.class.loaders.field.count': {
    ko: '개수',
    ja: '数',
    en: 'Count',
    cn: '',
  },
  'statistics.java.os.fsys.field.usage.rate': {
    ko: '사용률',
    ja: '使用率',
    en: 'Usage Rate',
    cn: '',
  },
  'statistics.abap.queue.field.count': {
    ko: '개수',
    ja: '数',
    en: 'Count',
    cn: '',
  },
  'statistics.java.os.disk.tps': {
    ko: 'Transfers per second',
    ja: '1秒当りの送信数',
    en: 'Transfers per second',
    cn: '',
  },
  'statistics.ex.msg': {
    ko: '에러 메시지',
    en: 'Error message',
    cn: 'Error message',
    ja: 'Error message',
  },
  'statistics.abap.lock.field.exclusive': {
    ko: 'Exclusive',
    ja: 'エクスクルーシブ',
    en: 'Exclusive',
    cn: '',
  },
  'statistics.java.os.disk.mw.sec': {
    ko: 'Write for second',
    ja: 'Write for second',
    en: 'Write for second',
    cn: '',
  },
  'statistics.abap.logon.user.field.system': {
    ko: 'System',
    ja: 'システム',
    en: 'System',
    cn: '',
  },
  'statistics.java.http.provider.field.response.time': {
    ko: '응답 시간',
    ja: '応答時間',
    en: 'Response time',
    cn: '',
  },
  'statistics.abap.os.network.field.in.kb': {
    ko: 'Traffic In (KB)',
    ja: 'トラフィックイン(KB)',
    en: 'Traffic In (KB)',
    cn: '',
  },
  'statistics.abap.os.disk.field.kb.sec': {
    ko: 'Transfered',
    ja: '送信済み',
    en: 'Transfered',
    cn: '',
  },
  'statistics.target': {
    ko: '대상',
    ja: '対象',
    en: 'Target',
    cn: '',
  },
  'statistics.java.jsp.field.response.count': {
    ko: '응답 수',
    ja: '応答数',
    en: 'Response Count',
    cn: '',
  },
  'statistics.java.system.thread.field.thread.pool.capacity.rate': {
    ko: 'Thread Pool Capacity Rate',
    ja: 'スレッドプール使用率',
    en: 'Thread Pool Capacity Rate',
    cn: '',
  },
  'statistics.abap.os.network.field.collisions': {
    ko: 'Collisions',
    ja: '衝突',
    en: 'Collisions',
    cn: '',
  },
  'statistics.java.log.size.field.log.size': {
    ko: 'Log size',
    ja: 'ログサイズ',
    en: 'Log size',
    cn: '',
  },
  'statistics.abap.os.network.field.out.packets': {
    ko: 'Out Packets',
    ja: 'アウトパケット',
    en: 'Out Packets',
    cn: '',
  },
  'statistics.abap.os.memory.field.swap.usage.rate': {
    ko: '스왑 사용률',
    ja: 'スワップ使用率',
    en: 'Swap Usage Rate',
    cn: '',
  },
  'statistics.memory.checkAll': {
    ko: '전체',
    ja: '全体',
    en: 'All Memory Type',
    cn: '',
  },
  'statistics.abap.dump.field.count': {
    ko: 'Dump Count',
    ja: 'ダンプ数',
    en: 'Dump Count',
    cn: '',
  },
  'statistics.java.application.thread.field.current.thread.count': {
    ko: 'Currnet Thread',
    ja: '現在のスレッド',
    en: 'Currnet Thread',
    cn: '',
  },
  'statistics.java.http.provider.field.request.count': {
    ko: '요청 수',
    ja: 'リクエスト数',
    en: 'Request Count',
    cn: '',
  },
  'statistics.max': {
    ko: '최대',
    ja: '最大',
    en: 'Maximum',
    cn: '',
  },
  'statistics.java.trxn.field.success.rate': {
    ko: 'Success Rate',
    ja: '成功率',
    en: 'Success Rate',
    cn: '',
  },
  'statistics.abap.os.fsys.field.usage.rate': {
    ko: '사용률',
    ja: '使用率',
    en: 'Usage Rate',
    cn: '',
  },
  'statistics.batch.rate': {
    ko: '진행률',
    ja: '進行率',
    en: 'Rate run batch',
    cn: '',
  },
  'statistics.inquire': {
    ko: '조회',
    ja: '照会',
    en: 'Inquire',
    cn: '',
  },
  'statistics.min': {
    ko: '최소',
    ja: '最小',
    en: 'Minimum',
    cn: '',
  },
  'statistics.abap.logon.user.field.rfc': {
    ko: 'RFC',
    ja: 'RFC',
    en: 'RFC',
    cn: '',
  },
  'statistics.java.trxn.field.timedout.count': {
    ko: 'Timedout',
    ja: 'タイムアウト',
    en: 'Timedout',
    cn: '',
  },
  'statistics.java.svc.status.field.count': {
    ko: '개수',
    ja: '数',
    en: 'Count',
    cn: '',
  },
  'statistics.table': {
    ko: '테이블',
    ja: 'テーブル',
    en: 'Table',
    cn: '',
  },
  'statistics.sum': {
    ko: '합계',
    ja: '合計',
    en: 'Sum',
    cn: '',
  },
  'statistics.chart': {
    ko: '차트',
    ja: 'チャート',
    en: 'Chart',
    cn: '',
  },
  'statistics.java.application.thread.field.active.thread.count': {
    ko: 'Active Threads',
    ja: 'アクティブスレッド',
    en: 'Active Threads',
    cn: '',
  },
  'statistics.abap.os.network.field.out.kb': {
    ko: 'Traffic Out (KB)',
    ja: 'トラフィックアウト(KB)',
    en: 'Traffic Out (KB)',
    cn: '',
  },
  'statistics.msg.stopped': {
    ko: '통계 배치 작업이 중단되었습니다.',
    ja: '統計バッチ作業が中止されました。',
    en: 'The batch process for compiling statistics was aborted.',
    cn: '',
  },
  'statistics.report': {
    ko: '프로그램',
    ja: 'プログラム',
    en: 'Program',
    cn: '',
  },
  'statistics.abap.workprcs.load.field.load': {
    ko: 'Load ratio',
    ja: 'ロード率',
    en: 'Load ratio',
    cn: '',
  },
  'statistics.date': {
    ko: '일시',
    ja: '日付',
    en: 'Date',
    cn: '',
  },
  'statistics.java.http.provider.field.response.count': {
    ko: '응답 수',
    ja: '応答数',
    en: 'Response Count',
    cn: '',
  },
  'statistics.java.system.thread.field.active.thread.count': {
    ko: 'Active Threads Count',
    ja: '有効なスレッド数',
    en: 'Active Threads Count',
    cn: '',
  },
  'statistics.java.enqueue.lock.field.count': {
    ko: 'Lock count',
    ja: 'ロック数',
    en: 'Lock count',
    cn: '',
  },
  'statistics.queue.checkAll': {
    ko: '전체',
    ja: '全体',
    en: 'All Queue Type',
    cn: '',
  },
  'statistics.java.application.thread.field.thread.pool.usage.rate': {
    ko: 'Thread Pool Usage',
    ja: 'スレッドプールの使用率',
    en: 'Thread Pool Usage',
    cn: '',
  },
  'statistics.java.os.network.field.rx': {
    ko: 'Rx',
    ja: 'Rx',
    en: 'Rx',
    cn: '',
  },
  'statistics.oneM': {
    ko: '1개월',
    ja: '1ヶ月',
    en: '1month',
    cn: '',
  },
  'statistics.abap.os.network.field.in.packets': {
    ko: 'In Packets',
    ja: 'インパケット',
    en: 'In Packets',
    cn: '',
  },
  'statistics.period.stop': {
    ko: '기간 재집계 중지',
    en: 'Stop re-counting',
    cn: '期间停止重新统计',
    ja: '期間 再集計 停止',
  },
  'statistics.abap.update.record.field.count': {
    ko: 'Update Count',
    ja: '更新数',
    en: 'Update Count',
    cn: '',
  },
  'statistics.oneH': {
    ko: '1시간',
    ja: '1時間',
    en: '1hour',
    cn: '',
  },
  'statistics.user': {
    ko: '사용자',
    ja: 'ユーザー',
    en: 'User',
    cn: '',
  },
  'statistics.oneD': {
    ko: '1일',
    ja: '1日',
    en: '1day',
    cn: '',
  },
  'statistics.period': {
    ko: '기간',
    en: 'Period',
    cn: '期间',
    ja: '期間',
  },
  'statistics.abap.memory.field.usage.rate': {
    ko: '사용률',
    ja: '使用率',
    en: 'Usage Rate',
    cn: '',
  },
  'statistics.category': {
    ko: '항목',
    ja: '項目',
    en: 'Category',
    cn: '',
  },
  'statistics.period.restart': {
    ko: '기간 통계 재집계',
    en: 'Re-count periodic statitstics',
    cn: '期间统计重新统计',
    ja: '期間 統計 再集計',
  },
  'statistics.abap.transaction.field.response.time': {
    ko: '응답 시간',
    ja: '応答時間',
    en: 'Response time',
    cn: '',
  },
  'statistics.java.trxn.field.suspended.count': {
    ko: 'Suspended',
    ja: '保留',
    en: 'Suspended',
    cn: '',
  },
  'statistics.tcode.chkValid': {
    ko: '를 선택 하세요.',
    ja: 'を選択してください。',
    en: 'Choose.',
    cn: '',
  },
  'statistics.tcode.inputValid': {
    ko: '를 입력 하세요.',
    ja: 'を入力してください。',
    en: 'Please enter',
    cn: '',
  },
  'statistics.abap.os.network.field.in.errors': {
    ko: 'In Errors',
    ja: 'エラー',
    en: 'In Errors',
    cn: '',
  },
  'statistics.workProcess': {
    ko: '워크프로세스',
    ja: 'ワークプロセス',
    en: 'Work Process',
    cn: '',
  },
  'statistics.java.trxn.field.transaction.count': {
    ko: 'Transaction count',
    ja: 'トランザクション数',
    en: 'Transaction count',
    cn: '',
  },
  'statistics.buffer.checkAll': {
    ko: '전체',
    ja: '全体',
    en: 'All Buffer Type',
    cn: '',
  },
  'statistics.java.heap.memory.field.usage.rate': {
    ko: '사용률',
    ja: '使用率',
    en: 'Usage Rate',
    cn: '',
  },
  'statistics.abap.applog.field.count': {
    ko: 'Log Count',
    ja: 'ログ数',
    en: 'Log Count',
    cn: '',
  },
  'statistics.java.os.memory.field.memory.usage.rate': {
    ko: 'Memory usage rate',
    ja: 'メモリ使用率',
    en: 'Memory usage rate',
    cn: '',
  },
  'statistics.taskType': {
    ko: 'Task Type',
    ja: 'タスクタイプ',
    en: 'Task type',
    cn: '',
  },
  'statistics.java.p4.field.error.request.count': {
    ko: 'Error Request Count',
    ja: 'エラーリクエスト数',
    en: 'Error Request Count',
    cn: '',
  },
  'statistics.abap.buffer.field.hitratio': {
    ko: '적중률',
    ja: 'ヒット率',
    en: 'Hit Ratio',
    cn: '',
  },
  'statistics.confirm.restart': {
    ko: '선택된 통계를 재집계합니다. 실행하시겠습니까?',
    ja: '選択した統計を再集計します。実行しますか？',
    en: 'Selected statistics will be compiled again. Would you like to start?',
    cn: '',
  },
  'statistics.java.os.disk.util': {
    ko: 'CPU time',
    ja: 'CPU時間',
    en: 'CPU time',
    cn: '',
  },
  // BEGIN::Added.by.KWShin.2026.02.25.
  'statistics.exe.user': {
    ko: '실행자',
    en: 'Executives',
    cn: 'Executives',
    ja: 'Executives',
  },
  // FINISH::Added.by.KWShin.2026.02.25.
};
